// extracted by css-extract-rspack-plugin
export default {"meter":"va_yoWgLp_s2B8bZ","rules":"nHp8WkR87IcUPp5p","terms":"kzSncq3Gj5AmJ7nd","altAction":"eyRAqQtYZEwnriVc"};